'use client'
import React from 'react';
import styled from "styled-components";
import {Col} from "react-bootstrap";
import reactHtmlParser from "react-html-parser";
import {Img} from "@/components/common/ui/Img";
import ThemeRow from "@/components/common/theme/row";
import {white} from "@/styles/globalStyleVars";

const InnerBanner = ({img, text, title,subtitle, data, paddingTop}) => {

    return (
        <StyledInnerBanner className='InnerBanner' paddingTop={paddingTop}>
            {
                img &&
                <Img parallax banner={true} src={img} alt={subtitle}/>

            }
           <ThemeRow>
              <Col md={6}>
                    <h1 className={'split-up'}>{reactHtmlParser(title)}</h1>
              </Col>
               <Col md={{span:4, offset: 2}}>
                   {
                       text &&
                       <p className={'split-up'}>{reactHtmlParser(text)}</p>
                   }
               </Col>
           </ThemeRow>
        </StyledInnerBanner>
    );
};

const StyledInnerBanner = styled.section`
    padding-top: ${props => props?.paddingTop ? `calc(520 / 1366 * 100%)`  : `calc(512 / 1366 * 100%)` } ;
    position: relative;
    background-color: #DDD;

    @media(min-width: 1024px){
        img{
            height: 120% !important;
            top: -50px !important;
        }
    }
    &:after {
        content: '';
        position: absolute;
        background-color: rgba(0, 0, 0, 0.35);
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
    }

    .container {
        position: absolute;
        margin: auto;
        left: 0;
        right: 0;
        bottom: 40px;
        z-index: 2;
        
        h1{
            font-size: 32px;
            line-height: 40px;
            letter-spacing: -0.32px;
            font-weight: 500;
            color: ${white};
            @media(max-width: 767px){
                margin-bottom: 40px;
            }
        }
        p{
            font-size: 16px;
            line-height: 24px;
            letter-spacing: -0.16px;
            color: ${white};
            
        }
    }



  
 
    @media(max-width: 991px){
        padding-top: calc(720 / 1366 * 100%);
        
    }

    @media (max-width: 767px) {
        //padding-top: 0;
        padding-top: calc(520 / 375 * 100%);
    }
`;

export default React.memo(InnerBanner);
